import type { ExtStyle } from "./types";

// Per document-type badge colors (no theme token exists for these).
export const EXT_STYLES: Record<string, ExtStyle> = {
  pdf: { color: "#DC2626", bg: "#FEE2E2" },
  doc: { color: "#2563EB", bg: "#DBEAFE" },
  docx: { color: "#2563EB", bg: "#DBEAFE" },
  ppt: { color: "#EA580C", bg: "#FFEDD5" },
  pptx: { color: "#EA580C", bg: "#FFEDD5" },
  xls: { color: "#16A34A", bg: "#DCFCE7" },
  xlsx: { color: "#16A34A", bg: "#DCFCE7" },
};

export const DEFAULT_EXT_STYLE: ExtStyle = { color: "#6B7280", bg: "#F3F4F6" };
export const LIBERTIFY_DEFAULT_PLAYBOOK_ORG_ID = "libertify-playbooks";
